/**
 * Meta (Facebook) Pixel initialization.
 * Loaded as a side-effect import in index.tsx (same pattern as sentry.ts).
 */

const PIXEL_ID = '4333216970292607';

// Bootstrap fbq queue before the script loads
const w = window as any;
if (!w.fbq) {
  const n: any = (w.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  });
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
}

// Load the fbevents.js script
const script = document.createElement('script');
script.async = true;
script.src = 'https://connect.facebook.net/en_US/fbevents.js';
try {
  document.head.appendChild(script);
} catch {
  // Meta Pixel script injection failed — non-blocking
}

// Init pixel and fire default PageView
w.fbq('init', PIXEL_ID);
w.fbq('track', 'PageView');
